export default __webpack_public_path__ + "static/media/qana-project-1.186ab2b6.webp";